import * as React from 'react';
import { Grid, Paper, Alert } from '@mui/material';

export default function NotFoundView() {
  return (
    <>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Alert severity="info">
            404 Not Found!
          </Alert>   
        </Paper>
      </Grid>
    </>
  );
}